import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../../services/archismall.service';

class ComponiFatturaPRSummaryController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'store',
        'jwtHelper',
        'ArchiSmallServices',
        '$uibModal'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private $http: ng.IHttpService,
        private configuration: any,
        private store: ng.a0.storage.IStoreService,
        private jwtHelper: any,
        private ArchiSmallServices: ArchiSmallServices,
        private $uibModal: ng.ui.bootstrap.IModalService
    ) {
        $scope.pageHeader = 'Componi Fattura';
        $scope.pageSubHeader = 'Riepilogo';
        var result = store.get('fatturazionepaComponiFattura-Result');
        if (result === undefined) {
            $state.go('home.home-index');
        }
        $scope.result = result;
        $scope.next = function () {
            store.remove('fatturazionepaComponiFattura-Result');
            store.remove('fatturazionepaComponiFattura');
            $state.go('home.fatturazione-pr');
        };
    }
}

export const ComponiFatturaPRSummaryComponent: ng.IComponentOptions = {
    template: require('./componi-fattura-pr-summary.html'),
    controller: ComponiFatturaPRSummaryController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/componi-fattura-pr-summary/componi-fattura-pr-summary.ts